import { useSelector } from "react-redux";

import { selectUserInfo } from "@store/globalSlice";
import useUserInfo from "@hooks/userInfo";

export const useUserNameDisplay = () => {
  const userInfo = useSelector(selectUserInfo);
  if (userInfo.firstName) {
    return [userInfo.firstName, userInfo.lastName].join(" ").trim();
  }
  if (userInfo.phoneCountryCode && userInfo.phoneNumber) {
    return ["+" + userInfo.phoneCountryCode, userInfo.phoneNumber].join(" ");
  }
  return "";
};
export const handleUserInfo = (userInfo: any) => {
  if (userInfo.firstName) {
    return [userInfo.firstName, userInfo.lastName].join(" ").trim();
  }
  return "";
};

export const useUserName = () => {
  const { userInfo } = useUserInfo();
  if (userInfo.firstName) {
    return [userInfo.firstName, userInfo.lastName].join(" ").trim();
  }
  return "";
};
